import { z } from "zod";

export const CommissionStatusSchema = z.enum([
  "pending",
  "paid",
  "cancelled",
]);
export type CommissionStatus = z.infer<typeof CommissionStatusSchema>;

export const CommissionSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  payeeName: z.string(),
  payeePhone: z.string().nullable(),
  amount: z.number().int(),
  status: CommissionStatusSchema,
  notes: z.string().nullable(),
  paidBy: z.string().nullable(),
  paidAt: z.coerce.date().nullable(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type CommissionDTO = z.infer<typeof CommissionSchema>;

export const CreateCommissionSchema = z.object({
  payeeName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່ຜູ້ຮັບ"),
  payeePhone: z.string().trim().nullable().optional(),
  amount: z.number().int().positive("ຍອດຕ້ອງຫຼາຍກວ່າ 0"),
  notes: z.string().trim().nullable().optional(),
  /** สร้างแล้วมาร์คว่าจ่ายเลยได้ */
  markPaid: z.boolean().optional().default(false),
});
export type CreateCommissionDTO = z.infer<typeof CreateCommissionSchema>;

export const UpdateCommissionSchema = z.object({
  payeeName: z.string().trim().min(1, "ຕ້ອງປ້ອນຊື່ຜູ້ຮັບ").optional(),
  payeePhone: z.string().trim().nullable().optional(),
  amount: z.number().int().positive("ຍອດຕ້ອງຫຼາຍກວ່າ 0").optional(),
  notes: z.string().trim().nullable().optional(),
});
export type UpdateCommissionDTO = z.infer<typeof UpdateCommissionSchema>;

export const CommissionParamSchema = z.object({
  eventId: z.string().min(1),
  commissionId: z.string().min(1),
});
